// useRouteAccess.js
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import routes from '../routes/routes';

const normalizeParent = (url) => (url ? url.split('/').slice(0, -1).join('/') : '');

export const checkRouteAccess = (pathname, routeList, menus) => {
  const isMatchInRoutes = routeList.map((route) => route.path).includes(pathname);

  const hasMenuData = Array.isArray(menus) && menus.length > 0;

  const isMatchInMenu = hasMenuData
    ? menus.some((menu) => {
      if (!menu.url) return false;
      return normalizeParent(menu.url) === normalizeParent(pathname);
      // return menu.url === pathname;

    })
    : true;

  return { isMatchInRoutes, isMatchInMenu };
};

export default function useRouteAccess() {
  const { pathname } = useLocation();
  const menus = useSelector((state) => state.menu.roleWiseData.menus);

  return useMemo(
    () => checkRouteAccess(pathname, routes, menus),
    [pathname, menus]
  );
}